import { lazy } from 'react';

const Home = lazy(() => import('../pages/home'));
const SearchResults = lazy(() => import('../pages/searchMap/SearchResults'));
const Login = lazy(() => import('../pages/auth/Login'));
const Register = lazy(() => import('../pages/auth/Register'));
const VerifyEmail = lazy(() => import('../pages/auth/VerifyEmail'));
const Profile = lazy(() => import('../pages/profile'));
const PaymentMethods = lazy(() => import('../pages/payment_methods'));
const CleanerDetail = lazy(() => import('../pages/cleaner_detail'));
const Messages = lazy(() => import('../pages/messages'));
const Chat = lazy(() => import('../pages/chat'));
const Bookings = lazy(() => import('../pages/bookings'));
const BookingDetail = lazy(() => import('../pages/bookings/BookingDetail'));
const NewReview = lazy(() => import('../pages/new_review'));
const ReviewConfirm = lazy(() => import('../pages/review/pages/ReviewConfirm'));
const EditBooking = lazy(() => import('../pages/bookings/EditBooking'));
const Favorites = lazy(() => import('../pages/favorites'));
const StripeSetup = lazy(() => import('../pages/profile/StripeSetup'));
const Collaborate = lazy(() => import('../pages/collaborate'));
const Checkout = lazy(() => import('../pages/checkout'));
const Guide = lazy(() => import('../pages/guide'));
const ProfileInfo = lazy(() => import('../pages/profile/ProfileInfo'));
// const LandingPage = lazy(() => import('../pages/landing_page'));
const WaitingList = lazy(() => import('../pages/waiting_list'));
const Settings = lazy(() => import('../pages/settings'));
const CleanerDashBoard = lazy(
  () => import('../pages/profile/CleanerDashBoard'),
);
const AppSettings = lazy(() => import('../pages/app_settings'));
const Managment = lazy(() => import('../pages/managment'));
const PendingReviews = lazy(() => import('../pages/pending_reviews'));

export enum APP_ROUTES {
  HOME = '/home',
  SEARCH = '/search',
  CLEANERS = '/cleaners',
  CLEANER_DETAIL = '/cleaners/:id',
  LOGIN = '/auth/login',
  REGISTER = '/auth/register',
  EMAIL_VERIFY = '/auth/verify-email',
  PROFILE = '/profile',
  JOIN_US = '/profile/join-us',
  STRIPE_SETUP = '/profile/stripe-setup',
  MESSAGES = '/messages',
  MESSAGE_DETAIL = '/messages/:id',
  BOOKINGS = '/bookings',
  BOOKING_DETAIL = '/bookings/:id',
  BOOKING_EDIT = '/bookings/:id/edit',
  BOOKING_REVIEW = '/bookings/:id/review',
  REVIEW_CONFIRMATION = '/bookings/:id/review/confirm',
  CALENDAR = '/calendar',
  FAVORITES = '/favorites',
  CHECKOUT = '/checkout',
  PROFILE_INFO = '/profile-info',
  WELCOME = '/',
  WAITING_LIST = '/waiting-list',
  CLEANER_DASHBOARD = '/dashboard',
  SETTINGS = '/settings',
  APP_SETTINGS = '/app-settings',
  MANAGMENT = '/management',
  PENDING_REVIEWS = '/pending-reviews',
  GUIDE = '/guide',
  PAYMENT_METHODS = '/payment-methods',
}

export const APP_ROUTES_CONFIG = [
  {
    path: APP_ROUTES.HOME,
    Element: Home,
  },
  {
    path: APP_ROUTES.SEARCH,
    Element: SearchResults,
  },
  {
    path: APP_ROUTES.CLEANER_DETAIL,
    Element: CleanerDetail,
  },
  {
    path: APP_ROUTES.LOGIN,
    Element: Login,
  },
  {
    path: APP_ROUTES.REGISTER,
    Element: Register,
  },
  {
    path: APP_ROUTES.EMAIL_VERIFY,
    Element: VerifyEmail,
  },
  {
    path: APP_ROUTES.PROFILE,
    Element: Profile,
  },
  {
    path: APP_ROUTES.STRIPE_SETUP,
    Element: StripeSetup,
  },
  {
    path: APP_ROUTES.MESSAGES,
    Element: Messages,
  },
  {
    path: APP_ROUTES.MESSAGE_DETAIL,
    Element: Chat,
  },
  {
    path: APP_ROUTES.BOOKINGS,
    Element: Bookings,
  },
  {
    path: APP_ROUTES.BOOKING_DETAIL,
    Element: BookingDetail,
  },
  {
    path: APP_ROUTES.BOOKINGS,
    Element: Bookings,
  },
  {
    path: APP_ROUTES.BOOKING_EDIT,
    Element: EditBooking,
  },
  {
    path: APP_ROUTES.BOOKING_REVIEW,
    Element: NewReview,
  },
  {
    path: APP_ROUTES.REVIEW_CONFIRMATION,
    Element: ReviewConfirm,
  },
  {
    path: APP_ROUTES.FAVORITES,
    Element: Favorites,
  },
  {
    path: APP_ROUTES.CHECKOUT,
    Element: Checkout,
  },
  {
    path: APP_ROUTES.JOIN_US,
    Element: Collaborate,
  },
  {
    path: APP_ROUTES.PROFILE_INFO,
    Element: ProfileInfo,
  },
  // {
  //   path: APP_ROUTES.WELCOME,
  //   Element: LandingPage,
  // },
  {
    path: APP_ROUTES.WAITING_LIST,
    Element: WaitingList,
  },
  {
    path: APP_ROUTES.SETTINGS,
    Element: Settings,
  },
  {
    path: APP_ROUTES.CLEANER_DASHBOARD,
    Element: CleanerDashBoard,
  },
  {
    path: APP_ROUTES.APP_SETTINGS,
    Element: AppSettings,
  },
  {
    path: APP_ROUTES.MANAGMENT,
    Element: Managment,
  },
  {
    path: APP_ROUTES.PENDING_REVIEWS,
    Element: PendingReviews,
  },
  {
    path: APP_ROUTES.GUIDE,
    Element: Guide,
  },
  {
    path: APP_ROUTES.PAYMENT_METHODS,
    Element: PaymentMethods,
  },
];
